module.exports = __webpack_public_path__ + "static/img/logo-scm.b0058c64.png";